<template>

    <div class="price-info">

        <template v-if="product.default_price">
            <div class="fw-bold">
                <template v-if="product.optimal_price.price < product.default_price.price">
                    {{ __('ab :price', {price: $options.filters.localizeAmount(product.optimal_price.price)}) }}
                </template>
                <template v-else>
                    {{ __(':price', {price: $options.filters.localizeAmount(product.optimal_price.price)}) }}
                </template>
            </div>
            <div class="" v-if="product.optimal_price.lower_bound > 1">
                {{ __('bei :lowerBound Stck.', {lowerBound: $options.filters.localizeNumber(product.optimal_price.lower_bound)}) }}
            </div>
        </template>

    </div>

</template>

<script>
    export default {
        props: [
            'product',
        ],
    }
</script>